function posToggleValidation() {
    const vm = this;
    vm.$onInit = () => {
        // custom validation
        vm.ngModel.$validators.oneFeatureSelected = function(modelValue) {
            // if returns false is means show display the message, it's invalid
            return modelValue;
        };
    };
}
angular.module('qkr.integration.settings')
    .component('posToggleValidation', {
        template: require('./pos-toggle-validation.html'),
        require: {ngModel: 'ngModel'},
        bindings: {
            integrationForm: '<',
            onChangeMagic: '&'
        },
        controller: posToggleValidation,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/types/pos-feature/pos.toggle.validation.component.js